import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verifica se o usuário está logado e se o token não está expirado
  if (!authService.isLoggedIn() || authService.isTokenExpired()) {
    router.navigate(['/login']); // Redireciona para a página de login
    return false;
  }

  // Obtém as roles do usuário armazenadas no sessionStorage (ou equivalente)
  const userRoles = sessionStorage.getItem('roles')
    ? JSON.parse(sessionStorage.getItem('roles')!)
    : [];

  // Obtém a role exigida para a rota a partir da configuração de dados
  const requiredRole = route.data?.['role'];

  if (requiredRole) {
    // Verifica se o usuário tem a role necessária
    if (!userRoles.includes(requiredRole)) {
      router.navigate(['/home']); // Redireciona para uma página inicial ou de acesso negado
      return false;
    }
  }

  return true; // Permite acesso se todas as condições forem satisfeitas
};
